export default "__VITE_PUBLIC_ASSET__c3984bb0__"